import { Vue, Component, Prop } from 'vue-property-decorator';
import { isMicroStandardId, getTaxonomyTags } from '@/utils/utils';
import TaxonomyCard from '../taxonomy-card/taxonomy-card';
import { AssessmentModel } from '@/models/content/assessment';
import { appConfigService } from '@/providers/services/app/app-config';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { sessionService } from '@/providers/services/auth/session';

@Component({
    name: 'assesment-card',
    components: {
        'taxonomy-card': TaxonomyCard,
        'material-icon': GoogleMaterialIcon,
    },
})

export default class AssessmentCard extends Vue {
    // ------------------------------------------------------------------------
    // Properties
    @Prop()
    private assessment: any;

    @Prop({default: false})
    private isMyContent!: boolean;

    private get tags() {
        return this.assessment.standards;
    }

    get userId() {
        return sessionService.getSession()!.user_id;
    }

    // --------------------------------------------------------------------------
    // Actions
    private onPlayAssessment(assessmentId: string) {
        const playerURL = `${window.location.origin}/library/player/${assessmentId}?source=rgo&type=assessment`;
        this.$emit('onOpenPlayer', playerURL);
    }

    private editAssessments(assesmentId: string) {
        const currentRoute = this.$router.currentRoute.path;
        const playerURL = `${window.location.origin}/library/content/assessments/edit/${assesmentId}?editing=true&redirectUrl=${currentRoute}`;
        window.location.href = playerURL;
    }

    private openPullout() {
        this.$emit('openPullout', this.assessment);
    }

    private filterCreator(creator: any) {
        this.$emit('filterCreator', creator);
    }

}
